// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2wlV9","approved":"Status_approved__34O1m","rejected":"Status_rejected__2Wu_c","expired":"Status_expired__2BlCY","label":"Status_label__2Q8u1"};